export function calculateBmiImperial(weightPounds: number, heightInches: number): number {
    // Check for invalid input to prevent errors
    if (weightPounds <= 0 || heightInches <= 0) {
        return 0;
    }

    // The imperial formula for BMI is (weight / height^2) * 703
    const bmi = (weightPounds / (heightInches * heightInches)) * 703;

    // Rounding the result to one decimal place for better readability, similar to how calculators display it
    return parseFloat(bmi.toFixed(1));
}
